import cx from 'classnames'
import { Check02 } from 'blaze-ui/icons/16/Check02'
import Styles from './VideoCaptionStyleModal.module.scss'

type Props = {
  label: string
  previewUrl: string
  isSelected: boolean
  onSelect: () => void
}

export const VideoCaptionStyleCard = ({ label, previewUrl, isSelected, onSelect }: Props) => {
  return (
    <button type="button" className={cx(Styles.card, { [Styles.selected]: isSelected })} onClick={onSelect}>
      <div className={Styles.previewWrapper}>
        <div className={Styles.preview}>
          <img src={previewUrl} alt={`${label} preview`} />
        </div>
        {isSelected && (
          <div className={Styles.checkmark} aria-hidden>
            <Check02 size={12} color="var(--dark-80)" />
          </div>
        )}
      </div>
      <span className={Styles.label}>{label}</span>
    </button>
  )
}
